var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    transform: "translate(-805 -688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3152",
    "data-name": "Group 3152",
    transform: "translate(0 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(809 711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "facebook-_176_",
    "data-name": "facebook-[#176]",
    d: "M333.775,7253v-6.3h1.913l.312-2.8h-2.225v-1.364c0-.722.019-1.436,1.026-1.436h1.021v-2a11.725,11.725,0,0,0-1.763-.1c-1.852,0-3.012,1.162-3.012,3.29v1.609H329v2.8h2.046v6.3Z",
    transform: "translate(-329 -7239)",
    fill: "#949494",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 14,
    height: 14,
    transform: "translate(805 711)",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.3aacb7385a73572f475382f34b3c039b.svg";
export { ForwardRef as ReactComponent };